<template>
    <div class="page">
        <Menu/>
        <div class="courseHead">
            <div class="img-box">
                <img :src="'/imgs/'+coursePkgInfo.display_img" alt/>
            </div>
            <div class="info-box">
                <div class="course-title">
                    <h1>{{coursePkgInfo.name}}</h1>
                    <div class="tools">
                        <Fav :isFav="coursePkgInfo.is_flow" :id="coursePkgInfo.id" :type="3"/>
                        <Share/>
                    </div>
                </div>
                <ul>
                    <li>课程:{{coursePkgInfo.course_count}}</li>
                    <li>学习人数:{{coursePkgInfo.learn_times}}</li>
                    <li>课程包有效期:{{coursePkgInfo.duration}}天</li>
                </ul>
                <div class="price">￥{{(coursePkgInfo.user_sales_price/100).toFixed(2)}}</div>
                <div class></div>
                <div class="tools">
                    <a v-if="coursePkgInfo.is_buy== 0" class="buy" href="javascript:void(0)" @click="buyCoursePkg">购买课程包</a>
                    <a v-if="coursePkgInfo.is_buy==1" href="javascript:void(0)" @click="startStudy" class="startStudy">开始学习</a>
                </div>
            </div>
        </div>

        <div class="course-content">
            <div class="tab">
                <ul>
                    <li @click="tab(1)">课程包介绍</li>
                    <li @click="tab(2)">课程包详情</li>
                </ul>
            </div>
            <div
                v-show="tabIndex===1"
                class="course-desc"
                v-html="coursePkgInfo.cont"
            >{{coursePkgInfo.cont}}
            </div>
            <div v-show="tabIndex===2" class="course-list">
                <CourseList :list="coursePkgCourses" :keyStr="'a'"/>
            </div>
        </div>
        <!--推荐课程-->
        <div class="recommend">
            <div class="title">其他推荐课程包</div>
            <CoursePkgList :list="recommendCoursePkgArr" :keyStr="'b'"/>
        </div>

        <!--加入购物车成功结果显示-->
        <div class="payresult-box" v-show="showCartResult==1">
            <div class="result">
                <div class="close" @click="closeResultClick">
                    <span class="iconfont icon-times"></span>
                </div>
                <div class="steate">课程包已成功加入购物车</div>
                <div class="buttons">
                </div>
            </div>
        </div>

        <Footer/>
    </div>
</template>

<script>
    import Menu from "@/components/Menu.vue";
    import CourseList from "@/components/CourseList.vue";
    import CoursePkgList from "@/components/CoursePkgList.vue";

    import Footer from "@/components/Footer.vue";
    import Share from "@/components/Share.vue";
    import Fav from "@/components/Fav.vue";
    import {coursePkgById, coursePkgItems, recommendCoursePkg} from "@/api/course.js";
    import {checkLogin} from "@/api/auth.js";
    import bus from "@/common/bus";

    export default {
        data() {
            return {
                coursePkgInfo: {},
                coursePkgCourses: [], //课程包课程
                tabIndex: 1,
                recommendCoursePkgArr: [], //推荐课程
                showCartResult: 0,
                isLogined: false, //是否已经登录
            };
        },
        mounted() {
            this.loadData(this.$route.params.id);
        },
        methods: {
            //开始学习
            startStudy: function () {
                this.tabIndex = 2
                this.$message({
                    message: "请点击课程详情里面的课程进行学习！",
                    type: 'warning'
                })
            },
            tab: function (index) {
                this.tabIndex = index;
            },
            loadData: function (id) {

                coursePkgById(id).then(resp => {
                    if (resp != -1) {
                        this.coursePkgInfo = resp;
                    }
                });
                coursePkgItems(id).then(resp => {
                    if (resp != -1) {
                        this.coursePkgCourses = resp;
                    }
                });

                //推荐课程
                recommendCoursePkg(id).then(resp => {
                    if (resp != -1) {
                        this.recommendCoursePkgArr = resp
                    }
                })

                if (checkLogin()) {
                    this.isLogined = true;
                } else {
                    this.isLogined = false;
                }

            },
            buyCoursePkg: function () {
                if (!this.isLogined) {
                    this.$message({
                        message: '您还未登录，请先登录！',
                        type: 'warning'
                    });
                    setTimeout(() => {
                        this.$router.push('/login');
                    }, 1200);
                    return;
                }

                this.coursePkgInfo.goods_name=this.coursePkgInfo.name;
                this.coursePkgInfo.goods_type=2;//商品类型,课程包
                this.coursePkgInfo.goods_id=this.coursePkgInfo.id;
                this.$router.push({
                    path: "/user/createOrderByGoods",
                    query: {
                        goodsInfo: JSON.stringify(this.coursePkgInfo),
                        goodsType: 2,
                    },
                });
            },
            closeResultClick: function () {
                this.showCartResult = 0;
            }
        },
        components: {
            Menu,
            Footer,
            Share,
            Fav,
            CourseList,
            CoursePkgList
        }
    };
</script>


<style lang="scss" scoped>
    body, .page {
        background: white;
    }

    //课程头部内容信息
    .courseHead {
        width: 1200px;
        margin: 0 auto;
        padding: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .img-box {
            background: #efefef;
            width: 372px;
            height: 210px;;
            border-radius: 10px;
            overflow: hidden;

            img {
                width: 100%;
            }
        }

        .info-box {
            flex: 1;
            margin-left: 30px;
            display: flex;
            flex-direction: column;
            align-content: space-between;
            justify-content: flex-start;

            .course-title {
                display: flex;
                flex-direction: row;
                align-content: space-between;
                margin-bottom: 20px;

                h1 {
                    flex: 1;
                }

                .tools {
                    color: #717171;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    width: 140px;
                }
            }

            ul {
                margin-bottom: 20px;

                li {
                    float: left;
                    margin-right: 20px;
                    color: #717171;
                    font-size: 1.6em;
                }
            }

            .price {
                clear: both;
                color: #f92626;
                font-size: 2.4em;
                font-weight: bold;
                margin-bottom: 20px;
            }

            .tools {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;

                .buy {
                    border: 1px solid red;
                    border-radius: 5px;
                    background: #fde9ea;
                    color: red;
                    font-size: 1.8em;
                    padding: 6px 15px;
                    display: block;
                    width: 100px;
                    text-align: center;
                }
                 .startStudy {
                    border: 1px solid #313131;
                    background: #313131;
                    color: white;
                }
            }

        }
    }

    //课程详细内容信息
    .course-content {
        width: 1200px;
        margin: 0 auto;
        border-top: 1px solid #e4e4e4;
        border-bottom: 1px solid #e4e4e4;

        .tab {
            background: #f7f9fc;
            height: 60px;
            line-height: 60px;

            li {
                float: left;
                padding: 0 30px;
                font-size: 1.8em;
            }

            li:hover {
                color: #313131;
                cursor: pointer;
            }
        }

        .course-desc, .course-list, .course-comment {
            font-size: 1.4em;
            clear: both;
            padding: 30px;
            color: #3a3a3a;
        }

        .course-list {
            margin-top: 30px;
            padding: 30px 0;
        }

        .course-comment {
            .item {
                padding: 20px;
                border-bottom: 1px solid #efefef;

                .comment {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    img {
                        width: 90px;
                        height: 90px;
                        display: block;
                        background: #efefef;
                        border-radius: 50%;
                    }

                    .info {
                        flex: 1;
                        margin: 10px 30px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;

                        .name {
                            color: #909090;
                            font-size: 1.4em;
                        }

                        .desc {
                            color: #909090;
                            font-size: 1.4em;
                        }
                    }

                    .time {
                        color: #909090;
                        font-size: 1.4em;
                    }
                }

                .replay {
                    background: #efefef;
                    padding: 20px;
                    margin-top: 20px;
                    font-size: 1.4em;
                }
            }

            .item:last-child {
                border-bottom: 0;
            }
        }
    }


    //视频背景
    .video-bg {
        background: #00000050;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .video {
            background: #545c63;
            margin: 0 auto;
            text-align: center;
            border-radius: 10px;

            .title {
                padding: 15px;
                color: white;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .name {
                    font-size: 1.4em;
                }

                .close {
                    font-size: 1.4em;
                    cursor: pointer;
                }
            }

            video {
                width: 100%;
                margin-bottom: 50px;
            }
        }
    }


    //推荐课程
    .recommend {
        width: 1200px;
        margin: 0 auto;
        margin-bottom: 40px;

        .title {
            font-size: 1.8em;
            padding: 20px;
        }

    }


    //购物车加入成功结果显示
    .payresult-box {
        background: #00000030;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;

        .result {
            padding: 20px 40px;
            background: white;
            text-align: center;
            display: block;
            margin: 0 auto;
            border-radius: 10px;
            position: relative;

            .close {
                width: 40px;
                height: 40px;
                position: absolute;
                right: 10px;
                top: 10px;
                cursor: pointer;
                color: #a0a0a0;
            }

            .steate {
                padding: 30px 50px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                font-size: 1.8em;
                color: #3b3b3b;
            }

            .buttons {
                padding: 30px 20px;

                .a1 {
                    background: red;
                    padding: 10px 25px;
                    color: white;
                    border-radius: 5px;
                    font-size: 1.4em;
                }
            }
        }
    }
</style>
